module.exports = __webpack_public_path__ + "static/media/MarkFollowUp.8abc6daa.svg";